export { googleConversionTracker } from './googleConversionTracker';
export { facebookConversionTracker } from './facebookConversionTracker';
export { resolveVendorEventName } from './conversionEventMap';

import { googleConversionTracker } from './googleConversionTracker';
import { facebookConversionTracker } from './facebookConversionTracker';
import type { ConversionTrackerRegistry } from '../useConversionTracker';

export const defaultConversionRegistry: ConversionTrackerRegistry = {
  google: googleConversionTracker,
  facebook: facebookConversionTracker,
};
